import { useEffect } from 'react';
import { useAppSelectorShallow, useAppDispatch } from 'store/hooks';
import { setIsOnHabitPacksTab } from 'store/reducer//habit-pack/slice';
import PackLists from './pack-lists';
import PackDetails from './PackDetails';

export default function HabitPacks() {
  const dispatch = useAppDispatch();
  const currentViewedPack = useAppSelectorShallow(
    (state) => state.habitPack.currentViewedPack
  );

  useEffect(() => {
    dispatch(setIsOnHabitPacksTab(true));
    return () => {
      dispatch(setIsOnHabitPacksTab(false));
    };
  }, [dispatch]);

  return (
    <div
      className={`flex w-full h-fit max-h-full sm:max-h-[99%] md:max-h-[98%] lg:max-h-[97%]`}>
      {currentViewedPack ? <PackDetails /> : <PackLists />}
    </div>
  );
}
